import React from "react";

/**
 * LogoutIcon component returning an SVG element.
 *
 * @return {JSX.Element} SVG element
 */
export const LogoutIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.3756 10.4951L17.1622 6.28174L15.9594 7.48873L19.6196 11.1489H7.6322V12.8513H19.6196L15.9594 16.5114L17.163 17.715L21.3764 13.5016C21.5741 13.304 21.7309 13.0693 21.8379 12.8111C21.9448 12.5529 21.9999 12.2762 21.9999 11.9967C21.9999 11.7172 21.9448 11.4404 21.8379 11.1822C21.7309 10.924 21.5741 10.6894 21.3764 10.4917L21.3756 10.4951Z"
        fill="currentColor"
      />
      <path
        d="M10.9171 19.6607C10.9171 19.8865 10.8274 20.103 10.6678 20.2626C10.5082 20.4222 10.2917 20.5119 10.0659 20.5119H4.55358C4.32783 20.5119 4.11133 20.4222 3.9517 20.2626C3.79207 20.103 3.70239 19.8865 3.70239 19.6607V4.33923C3.70239 4.11348 3.79207 3.89697 3.9517 3.73734C4.11133 3.57771 4.32783 3.48803 4.55358 3.48803H10.0659C10.2917 3.48803 10.5082 3.57771 10.6678 3.73734C10.8274 3.89697 10.9171 4.11348 10.9171 4.33923V8.87864H12.6195V4.33923C12.6195 3.66197 12.3505 3.01246 11.8716 2.53357C11.3927 2.05468 10.7432 1.78564 10.0659 1.78564L4.55358 1.78564C3.87633 1.78564 3.22682 2.05468 2.74793 2.53357C2.26904 3.01246 2 3.66197 2 4.33923L2 19.6607C2 20.338 2.26904 20.9875 2.74793 21.4664C3.22682 21.9453 3.87633 22.2143 4.55358 22.2143H10.0659C10.7432 22.2143 11.3927 21.9453 11.8716 21.4664C12.3505 20.9875 12.6195 20.338 12.6195 19.6607V15.1213H10.9171V19.6607Z"
        fill="currentColor"
      />
    </svg>
  );
};
